function arrayToUrl(arr) {
    let out = [];
    for (let key in arr) {
        out.push(key + '=' + encodeURIComponent(arr[key]));
    }

    let out_string = out.join('&');
    if(out_string!='') {
        return '?'+out_string;
    }
}

function getObjectSize(obj) {
    let count = 0;
    for(let k in obj) {
        count++;
    }
    return count;
}

function str_random(length) {
    return Math.random().toString(36).substring(2, length+2);
}

function str_slug(text) {
    return text.toLowerCase()
        .replace(/[^\w ]+/g, '')
        .replace(/ +/g, '-');
}

function inArray(needle, haystack) {
    if(haystack) {
        var length = haystack.length;
        for (var i = 0; i < length; i++) {
            if (haystack[i] == needle) return true;
        }
    }
    return false;
}

function baseFuncMenuOn(class_name) {
    $(".menu_ul_"+class_name).find(".on").each(
        function() {
            $(this).closest('ul').parent('li').children("div").addClass("on");
        }
    );
    $(".menu_ul_"+class_name).find(".on").each(
        function() {
            $(this).closest('ul').parent('li').children("div").addClass("on");
        }
    );
    $(".menu_ul_"+class_name).find(".on").each(
        function() {
            $(this).closest('ul').parent('li').children("div").addClass("on");
        }
    );
    $(".menu_ul_"+class_name).find(".on").each(
        function() {
            $(this).closest('ul').parent('li').children("div").addClass("on");
        }
    );
    $(".menu_ul_"+class_name).find(".on").each(
        function() {
            $(this).closest('ul').parent('li').children("div").addClass("on");
        }
    );
}

function generatePassword() {
    let charset = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let numbers = "0123456789";
    let specialCharts = '!#?%^&$*';
    let retVal = "";
    for (var i = 0, n = charset.length; i < 15; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n));
    }
    for (var i = 0, n = numbers.length; i < 5; ++i) {
        retVal += numbers.charAt(Math.floor(Math.random() * n));
    }
    for (var i = 0, n = specialCharts.length; i < 1; ++i) {
        retVal += specialCharts.charAt(Math.floor(Math.random() * n));
    }
    return retVal;
}

function setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    var expires = "expires="+ d.toUTCString();
    if(cs===undefined||cs==0) {
        cs = '';
    }
    else {
        cs = ' Secure ;';
    }

    document.cookie = cname + "=" + cvalue + ";" + expires + "; "+cs+"path=/";
}

function getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i <ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

function htmlSpecialChars(text) {
    return text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
}

function htmlSpecialCharsDecode(text) {
    var map = {
        '&amp;': '&',
        '&#038;': "&",
        '&lt;': '<',
        '&gt;': '>',
        '&quot;': '"',
        '&#039;': "'",
        '&#8217;': "’",
        '&#8216;': "‘",
        '&#8211;': "–",
        '&#8212;': "—",
        '&#8230;': "…",
        '&#8221;': '”'
    };

    return text.replace(/\&[\w\d\#]{2,5}\;/g, function(m) { return map[m]; });
}


function number_format(number, decimals, decPoint, thousandsSep) {

    number = (number + '').replace(/[^0-9+\-Ee.]/g, '')
    var n = !isFinite(+number) ? 0 : +number
    var prec = !isFinite(+decimals) ? 0 : Math.abs(decimals)
    var sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep
    var dec = (typeof decPoint === 'undefined') ? '.' : decPoint
    var s = ''

    var toFixedFix = function (n, prec) {
        if (('' + n).indexOf('e') === -1) {
            return +(Math.round(n + 'e+' + prec) + 'e-' + prec)
        } else {
            var arr = ('' + n).split('e')
            var sig = ''
            if (+arr[1] + prec > 0) {
                sig = '+'
            }
            return (+(Math.round(+arr[0] + 'e' + sig + (+arr[1] + prec)) + 'e-' + prec)).toFixed(prec)
        }
    }

    s = (prec ? toFixedFix(n, prec).toString() : '' + Math.round(n)).split('.')
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep)
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || ''
        s[1] += new Array(prec - s[1].length + 1).join('0')
    }

    return s.join(dec)
}

function removeObjFromArrByValue(objects_arr, object_to_remove, param_name) {
    for(let k in objects_arr) {
        let obj = objects_arr[k];
        if(obj[param_name]==object_to_remove[param_name]) {
            objects_arr.splice(k, 1);
        }
    }
}

function initSingsCounter(element, limit = 500){
    if(element.length>0) {
        updateSingsLength();
        $(element).unbind('keyup').keyup(function(){
            let len = element.val().length;
            if(len>limit){
                $(element).val($(element).val().substring(0,limit));
            }
            updateSingsLength();
        });
    }

    function updateSingsLength() {
        $(element).parent().find('.sign_count p').html($(element).val().length + '/'+limit);
        if($(element).val().length>=limit) {
            $(element).parent().find('.sign_count').addClass('err_txt');
        }
        else {
            $(element).parent().find('.sign_count').removeClass('err_txt');
        }
    }
}

function wcagPopupFocus(popup_element) {
    let HTML_popup = popup_element;
    if(HTML_popup.length==1) {
        let HTML_focusable_elements = $(HTML_popup).find('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
        if(HTML_focusable_elements.length>0) {

            let interval = setInterval(function(){
                $(HTML_popup).find(".wcag-popup-first:visible").focus();
            },100);
            $(HTML_popup).find(".wcag-popup-first:visible").bind('focusin',function(){
                clearInterval(interval);
            });

            document.addEventListener('keydown', function(e) {
                let is_tab_pressed = e.key === 'Tab' || e.keyCode === 9;

                if (!is_tab_pressed) {
                    return;
                }

                if (e.shiftKey) {
                    if ($(document.activeElement).is($(HTML_popup).find(".wcag-popup-first:visible"))) {
                        $(HTML_popup).find(".wcag-popup-last:visible").focus();
                        e.preventDefault();
                    }
                }
                else {
                    if ($(document.activeElement).is($(HTML_popup).find(".wcag-popup-last:visible"))) {
                        $(HTML_popup).find(".wcag-popup-first:visible").focus();
                        e.preventDefault();
                    }
                }
            });
        }
    }
}

function pesel_birth_date(pesel_input_class, birthdate_input_class, sex_select_class) {

    let pesel_input = !(typeof pesel_input_class === 'string') ? $(pesel_input_class) : $("."+pesel_input_class);
    let birthdate_input = !(typeof birthdate_input_class === 'string') ? $(birthdate_input_class) : $("."+birthdate_input_class);
    let sex_select = !(typeof sex_select_class === 'string') ? $(sex_select_class) : $("."+sex_select_class);

    if($(pesel_input).length==1) {

        $(pesel_input).keyup(function () {
            let pesel = $(pesel_input).val();

            if($(birthdate_input).length==1) {
                if (pesel.length >= 6) {
                    let year = pesel.substr(0, 2) * 1 / 1;
                    let month = pesel.substr(2, 2) * 1 / 1;
                    let day = pesel.substr(4, 2) * 1 / 1;
                    if (!isNaN(year) && !isNaN(month) && !isNaN(day)) {
                        if (month >= 81 && month <= 92) {
                            year = 1800 + year;
                            month -= 80;
                        } else if (month >= 21 && month <= 32) {
                            year = 2000 + year;
                            month -= 20;
                        } else {
                            year = 1900 + year;
                        }

                        if (day < 10) {
                            day = "0" + day;
                        }
                        if (month < 10) {
                            month = "0" + month;
                        }
                    }
                    let bd = '';
                    if(!$(birthdate_input).hasClass("input_date_clear")) {
                        bd = year + "-" + month + "-" + day;
                    }
                    else {
                        bd = day + "-" + month + "-" + year;
                    }
                    $(birthdate_input).val(bd).trigger('change');
                }
            }

            if($(sex_select).length==1) {
                if (pesel.length >= 10) {
                    let sex_no = pesel.substr(9, 1) * 1 / 1;
                    if (!isNaN(sex_no)) {
                        let sex = null;
                        if (sex_no % 2 == 0) {
                            sex = "female";
                        } else {
                            sex = "male";
                        }
                        if (sex) {
                            $(sex_select).val(sex).trigger('change').trigger('chosen:updated');
                        }
                    }
                }
            }
        });
    }
}

function svgMapScale(map_box_parent) {
    var map_svg = $(map_box_parent).find("svg")[0];

    mapa_skaluj();

    function mapa_skaluj() {

        var width = $(map_svg).parent().width();
        $(map_svg).css("height",width*1+"px");

        $(window).resize(
            function() {
                var width = $(map_svg).parent().width();
                $(map_svg).parent().css("height",width*0.8+"px");
            }
        );

        let path = $(map_svg).find("g")[0];

        let b = path.getBBox();

        map_svg.setAttribute("viewBox", b.x+" "+b.y+" "+b.width+" "+b.height);
    }
}

function addStringToClipboardCopy() {
    var selection = window.getSelection();
    var final_copy_text = copy_text;
    final_copy_text = final_copy_text.replace('{url}',document.location.href);
    final_copy_text = final_copy_text.replace('{text}',selection);
    newdiv = document.createElement('div');


    newdiv.style.position = 'absolute';
    newdiv.style.left = '-99999px';

    document.body.appendChild(newdiv);
    newdiv.innerHTML = final_copy_text;
    selection.selectAllChildren(newdiv);

    window.setTimeout(function () {
        document.body.removeChild(newdiv);
    }, 100);
}

if(typeof copy_text != 'undefined') {
    document.addEventListener('copy', addStringToClipboardCopy);
}

function putLogoutEvent(btnClass, csrfToken)
{
    $('.' + btnClass).click(function () {
        $.ajax({
            url: $(this).attr('href'),
            method: 'POST',
            headers: {
                'X-CSRF-TOKEN': csrfToken
            }
        }).done(function () {
            window.location.reload();
        });

        return false;
    });
}

function mobileAndTabletCheck() {
    let check = false;
    (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
    return check;
}